import Skeleton from './Skeleton';

/**
 * One or more text line placeholders.
 * @param {number} lines - Number of lines (default 3)
 * @param {number} gap   - Gap between lines in px (default 8)
 */
const TextLineSkeleton = ({ lines = 3, gap = 8 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap }}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        height={12}
        width={i === lines - 1 ? '60%' : '100%'}
      />
    ))}
  </div>
);

export default TextLineSkeleton;
